<template>
  <div class="page">
    <div class="app-container">
      <!-- 搜索 -->
      <BaseSearch
        v-model="searchData"
        :formOptions="searchFormOption"
        @handleSearch="handleSearch"
      ></BaseSearch>
      <BaseTable
        ref="baseTable"
        url="/admin/insbilloffer/getlist"
        :tableData.sync="tableData"
        :columns="columns"
        :searchParams="searchData"
      >
        <template #custom="{ scope }">
          {{ scope.row.title }}
        </template>
        <template #handle="{ row }">
          <el-button type="text" @click="hanldeRow(row, 'detail')"
            >详情</el-button
          >
          <el-button type="text" @click="hanldeRow(row, 'edit')"
            >编辑</el-button
          >
          <el-button type="text" size="mini" @click="hanldeRow(row, 'discount')"
            >客户折扣</el-button
          >
          <el-button type="text" size="mini" @click="hanldeRow(row, 'audit')"
            >提交审核</el-button
          >
          <el-popover
            placement="bottom"
            width="300"
            trigger="click"
            style="margin-left: 10px"
            @show="showPop(row)"
          >
            <el-table :data="offerTempList" style="width: 100%">
              <el-table-column label="选择模板" width="180">
                <template slot-scope="scope">
                  <span style="margin-left: 10px">{{ scope.row.company }}</span>
                </template>
              </el-table-column>
              <el-table-column>
                <template slot-scope="scope">
                  <el-button
                    size="mini"
                    @click="tempSel(scope.$index, scope.row)"
                    >选择</el-button
                  >
                </template>
              </el-table-column>
            </el-table>
            <!-- <el-button type="text" size="mini" slot="reference" @click="hanldeRow(row, 'bill')" -->
            <el-button type="text" size="mini" slot="reference"
              >报价单</el-button
            >
          </el-popover>

          <!-- <el-button
            type="text"
            size="mini"
            @click="hanldeRow(row, 'sendSms')"
            >发送短信</el-button> -->
        </template>
      </BaseTable>
      <el-dialog
        :title="dialogTitle"
        :visible.sync="dialogVisible"
        width="30%"
        @close="dialogClosed"
      >
        <BaseForm
          ref="baseForm"
          v-model="formData"
          :rules="rules"
          :formOptions="discountFormOption"
          @formChange="formChange"
        ></BaseForm>
        <span style="color: red" v-if="customerRebateCk > 0"
          >&nbsp&nbsp&nbsp&nbsp客户折扣参考值：{{ customerRebateCk }}</span
        >
        <span slot="footer" class="dialog-footer">
          <el-button size="small" @click="dialogVisible = false"
            >取 消</el-button
          >
          <el-button size="small" type="primary" @click="handleSubmit"
            >确 定</el-button
          >
        </span>
      </el-dialog>
      <el-drawer
        title="报价单"
        :visible.sync="drawerVisible"
        :close="drawerClose"
        size="880px"
      >
        <div
          ref="imageWrapper"
          style="
            padding: 20px;
            width: 794px;
            height: 1058px;
            font-family: '宋体';
          "
        >
          <div class="table-title">
            <img
              :src="quotation.company_logo + '?a=' + new Date().getTime()"
              crossorigin="anonymous"
              style="width: 120px; height: 120px; margin-bottom: -50px"
            />
            {{ quotation.company }}报价单
          </div>
          <div
            class="info-wrap bg-img"
            :style="{
              'background-image': 'url(' + quotation.company_watermark + ')',
            }"
          >
            <!-- <div class="info-wrap bg-img"> -->
            <!-- <div class="watermark">
			  <img :src="quotation.company_logo" crossorigin="anonymous" style="width:500px;height: 500px;">
		  </div> -->
            <div class="base-info">
              <!-- <BaseInfo
              :infoOptions="InfoOption"
              :infoData="infoData"
              itemWidth="45%"
            /> -->
            </div>

            <div class="row-item">
              <div>被服务人</div>
              <div class="div-left">{{ infoData.b_personName }}</div>
              <div>车 牌 号</div>
              <div class="div-left">{{ infoData.carNo }}</div>
            </div>
            <div class="row-item">
              <div>发动机号</div>
              <div class="div-left">{{ infoData.engineNo }}</div>
              <div>车 架 号</div>
              <div class="div-left">{{ infoData.vin }}</div>
            </div>
            <div class="row-item">
              <div>车&nbsp&nbsp型</div>
              <div class="div-left">{{ infoData.carType }}</div>
              <div>营运性质</div>
              <div class="div-left">{{ infoData.usetype }}</div>
            </div>
            <div class="row-item">
              <div>品牌型号</div>
              <div class="div-left">{{ infoData.brandType }}</div>
              <div>初登日期</div>
              <div class="div-left">{{ infoData.beginDate }}</div>
            </div>
            <div class="row-item">
              <div>核定载质量</div>
              <div class="div-left">{{ infoData.loadWeight }}</div>
              <div>核定载客</div>
              <div class="div-left">{{ infoData.passengerCount }}</div>
            </div>
            <div class="row-item">
              <div>服务起始时间</div>
              <div class="div-left" style="min-width: 536.8px">
                &nbsp自 {{ infoData.beginTime }} &nbsp起 至&nbsp
                {{ infoData.endTime }} &nbsp止
              </div>
            </div>

            <div class="row-item row-item-head" style="font-family: '黑体'">
              <div>服务种类</div>
              <div>责任限额(元)</div>
              <div>标准费用(元)</div>
              <div>服务费(元)</div>
            </div>
            <div
              class="row-item"
              v-for="item in infoData.detail"
              :key="item.id"
            >
              <div>{{ item.name }}</div>
              <div>
                {{
                  item.type_id === 4 || item.type_id === 8
                    ? item.special_fee + ' * ' + (infoData.passengerCount - 1)
                    : item.tcfee
                }}
              </div>
              <div>{{ item.bztcfee }}</div>
              <!-- <div>{{ (item.yjtcfee * infoData.customerRebate) || '' }}</div> -->
              <div>{{ item.fwfee || '' }}</div>
            </div>
            <div class="row-item">
              <div></div>
              <div>标准服务费合计（元）</div>
              <!-- <div style="color: red;font-weight: bolder">{{ infoData.cusFee * infoData.customerRebate }}</div> -->
              <div style="color: red; font-weight: bolder">{{ bfwfeeHe }}</div>
            </div>
            <div class="row-item">
              <div>
                折扣<span style="color: red; font-weight: bolder">{{
                  infoData.customerRebate
                }}</span>
              </div>
              <div>应交服务费合计（元）</div>
              <!-- <div style="color: red;"></div> -->
              <!-- <div style="color: red;font-weight: bolder">{{ infoData.cusFee * infoData.customerRebate }}</div> -->
              <div style="color: red; font-weight: bolder">{{ fwfeeHe }}</div>
            </div>
          </div>

          <div class="row-item jiaoqiang">代报交强</div>
          <div class="info-wrap" style="border-top: 1px solid #000000">
            <div class="row-item">
              <div style="font-size: 16px">代报金额(元)</div>
              <div style="font-size: 16px">{{ infoData.compulsory }}</div>
              <div style="font-size: 16px">车船税(元)</div>
              <div style="font-size: 16px">{{ infoData.vessels }}</div>
              <div
                style="
                  font-size: 16px;
                  font-weight: bolder;
                  font-family: '黑体';
                "
              >
                总合计(元)
              </div>
              <div style="font-size: 16px">{{ zfeeHe }}</div>
            </div>
          </div>
          <div class="info-footer">
            <span style="float: left"
              >报价时间：{{ infoData.update_time }}</span
            >
            <span style="float: right">报价人：{{ infoData.offerName }}</span>
          </div>
          <div style="clear: both"></div>
          <div
            class="remark"
            style="
              clear: both;
              margin-top: 10px;
              font-size: 17px;
              font-weight: bold;
            "
          >
            <div class="remark-title">备注：</div>
            <div class="remark-text">
              (1)
              验车要求：车身前后左右45º角照共4张照片拍全车身、1张车架号照，每张照片上附当日验车码。
            </div>
            <div class="remark-text">(2) 实际服务费以审核通过为准。</div>
            <!-- <div class="remark-text" style="color: red;">(3) 客户交纳服务费用，用对公账户转账最终金额可减30元。</div> -->
            <div class="remark-text" style="color: red">
              (3) 支付宝限时立减优惠，单笔最高可省200元。
            </div>
          </div>
        </div>
        <div class="info-footer">
          <el-button
            size="small"
            type="primary"
            @click="onExport"
            id="onExport"
          >
            复制报价单
          </el-button>
        </div>
      </el-drawer>
    </div>
  </div>
</template>

<script>
import { searchFormOption, discountFormOption, InfoOption } from './formOptions'
import { columns } from './columns'
import { rules } from './rules'
import html2canvas from 'html2canvas'

export default {
  name: 'Offer',
  comments: {},
  data() {
    return {
      tableData: [],
      searchData: {},
      selectOption: [],
      cascaderOption: [],
      // 弹框相关
      dialogTitle: '',
      dialogVisible: false,
      // 表单相关
      formData: {},
      // 报价单相关
      drawerVisible: false,
      infoData: {
        detail: [],
      },
      rules: rules(this),
      insBillId: '',
      // 报价单的公司、Logo、公章
      quotation: {
        company: '',
        company_logo: '',
        official_seal: '',
      },
      // 应交服务费合计
      fwfeeHe: 0,
      // 标准服务费合计
      bfwfeeHe: 0,
      // 总费合计
      zfeeHe: 0,
      // 客户折扣参考值
      customerRebateCk: 0,
      offerTempList: [],
      selRow: {},
    }
  },
  computed: {
    columns,
    searchFormOption,
    discountFormOption,
    InfoOption,
  },
  created() {
    this.getOfferTemp()
  },
  methods: {
    // 获取详情信息
    async getDetail(insBillId, temprow) {
      this.fwfeeHe = 0
      this.bfwfeeHe = 0
      // const res = await this.$api.post("/admin/insbill/getDetailByBid", {
      //   insBillId,
      // });
      const res = await this.$api.post('/admin/insbill/getTheDetail', {
        keyword: insBillId,company_id:temprow.id
      })
      let b_personName = ''
      let z_personName = ''
      res.data.person.forEach((el, ind) => {
        if (ind === 0) {
          b_personName = el.personName
        }
        if (ind === 2) {
          z_personName = el.personName
        }
      })
      let detail = []
      let bztcfeeHe = 0
      for (let i = 0; i < 7; i++) {
        if (res.data.item[i] == undefined) {
          detail.push([])
        } else {
          res.data.item[i].fwfee = (
            res.data.item[i].bztcfee * res.data.base.customerRebate
          ).toFixed(2)
          bztcfeeHe += parseFloat(res.data.item[i].bztcfee)
          detail.push(res.data.item[i])
        }
      }
      this.bfwfeeHe = bztcfeeHe.toFixed(2)
      this.fwfeeHe = (bztcfeeHe * res.data.base.customerRebate).toFixed(2)

      this.zfeeHe = (
        parseFloat(this.fwfeeHe) +
        parseFloat(res.data.base.compulsory) +
        parseFloat(res.data.base.vessels)
      ).toFixed(2)

      this.infoData = {
        ...res.data.base,
        ...res.data.car,
        detail: detail,
        planTime: `自${res.data.base.beginTime} 起 至 ${res.data.base.endTime} 止`,
        b_personName,
        z_personName,
      }
      // const quotationRes = await this.$api.post("/admin/org/getQuotation", {});

      // this.quotation = {...quotationRes.data}
      this.quotation = temprow
      console.log(this.quotation)
    },

    async getOfferTemp() {
      const res = await this.$api.post('/admin/companyQuotation/index', {})
      this.offerTempList = res.data.data
    },
    tempSel(index, row) {
      console.log('index===', index)
      console.log('row===', row)

      this.hanldeRow(this.selRow, 'bill', row)
    },
    showPop(row) {
      this.selRow = row
    },
    // 点击搜索
    handleSearch() {
      //console.log(this.searchData);
      this.$refs.baseTable.searchData()
    },

    // 搜索参数拦截
    paramsCepCallback(params) {
      return {
        ...params,
        ...this.searchData,
      }
    },

    hanldeRow(row, k, temprow) {
      switch (k) {
        case 'detail':
          this.$router.push({
            path: '/issue/detail',
            query: {
              insBillId: row.insBillId,
            },
          })
          break
        case 'edit':
          this.$router.push({
            path: '/issue/recording',
            query: {
              insBillId: row.insBillId,
            },
          })
          break
        case 'discount':
          this.handleDiscount(row)
          break
        case 'audit':
          this.handleAudit(row)
          break
        case 'bill':
          this.drawerVisible = true
          this.getDetail(row.insBillId, temprow)
          this.insBillId = row.insBillId
          break
        case 'sendSms':
          this.$confirm(`是否确认发送短信?`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              await this.$api.post(
                '/admin/customer/sendSms',
                { vin: row.vin, insbillId: row.insBillId },
                '发送',
              )
              this.handleSearch()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作',
              })
            })
          break
        default:
          break
      }
    },

    // 点击设置折扣
    handleDiscount(row) {
      this.dialogTitle = `${row.insBillId} 设置折扣`
      this.dialogVisible = true
      if (row.customerRebate < 1) {
        if (row.customerFee == null) {
          row.customerFee = (row.contractFee * row.customerRebate).toFixed(2)
        }
        this.formData = {
          ...row,
          customerRebate: row.customerRebate,
          cusFee: row.customerFee,
        }
      } else {
        this.formData = {
          ...row,
          customerRebate: row.customerRebate,
        }
      }
    },
    // formChange
    formChange(val, prop) {
      if (prop === 'customerRebate') {
        this.formData.cusFee = (val * this.formData.contractFee).toFixed(2)
        this.customerRebateCk = val
      }
      if (prop === 'cusFee') {
        if (this.formData.contractFee > 0) {
          this.customerRebateCk = val / this.formData.contractFee
        }
      }
    },
    // 点击审核
    async handleAudit({ insBillId }) {
      this.$confirm('是否确认提审, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      })
        .then(async () => {
          await this.$api.post(
            '/admin/insbilloffer/submit',
            { insBillId },
            '提交审核',
          )
          this.handleSearch()
        })
        .catch(() => {
          this.$message({
            type: 'info',
            message: '已取消操作',
          })
        })
    },
    // 提交
    handleSubmit() {
      // const fei = this.formData.nature.includes('非营业');
      // if(fei == true){
      // 	if(this.formData.customerRebate < 0.8){
      // 		this.$message.error("非营运车辆折扣不得低于0.8");
      // 		return;
      // 	}
      // }else{
      // 	if(this.formData.customerRebate < 0.5){
      // 		this.$message.error("营运车辆折扣不得低于0.5");
      // 		return;
      // 	}
      // }
      this.$refs.baseForm.onSubmit((validate) => {
        if (validate) {
          //console.log(this.formData);
          this.$confirm('是否确认提交, 是否继续?', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              await this.$api.post(
                '/admin/insbilloffer/setCusRebate',
                { ...this.formData },
                '设置折扣',
              )
              this.dialogVisible = false
              this.handleSearch()
            })
            .catch(() => {
              this.$message({
                type: 'info',
                message: '已取消操作',
              })
            })
        }
      })
    },
    // 抽屉关闭
    drawerClose() {},
    // 弹框关闭
    dialogClosed() {
      this.formData = {}
      this.$refs.baseForm.resetFields()
    },
    //生成统筹单图片
    onExport() {
      //const clientWidth = this.$refs.imageWrapper.offsetWidth;
      //const clientHeight = this.$refs.imageWrapper.offsetHeight;
      const loading = this.$loading({
        lock: true, // 是否禁止背景滚动，默认为false
        text: '图片复制中,请耐心等待···', // 加载文本提示，默认为'Loading'
        spinner: 'el-icon-loading', // 加载图标类型，默认为'el-icon-loading'
        background: 'rgba(0, 0, 0, 0.7)', // 遮罩层背景颜色，默认为'rgba(0, 0, 0, 0.7)'
      })
      const clientWidth = 794
      const clientHeight = 1058

      const kh = [clientWidth, clientHeight]

      html2canvas(this.$refs.imageWrapper, {
        useCORS: true,
        logging: true,
      }).then((canvas) => {
        //const dataURL = canvas.toDataURL('image/png');
        // link.href = base64;
        // link.download = `${this.insBillId}报价单.png`;
        // link.click();

        canvas.toBlob((blob) =>
          navigator.clipboard.write([
            new window.ClipboardItem({ [blob.type]: blob }),
          ]),
        )
        this.$message({
          type: 'success',
          message: '复制成功',
        })
        loading.close()
        //this.download(dataURL, kh);
      })
    },
    //获取图片base64
    getUrlBase64(url, kh) {
      return new Promise((resolve) => {
        let canvas = document.createElement('canvas')
        const ctx = canvas.getContext('2d')
        let img = new Image()
        img.crossOrigin = 'Anonymous' // 允许跨域
        img.src = url
        img.onload = () => {
          // eslint-disable-next-line prefer-destructuring
          canvas.height = kh[1]
          // eslint-disable-next-line prefer-destructuring
          canvas.width = kh[0]
          ctx.drawImage(img, 0, 0, kh[0], kh[1])
          const dataURL = canvas.toDataURL('image/png')
          canvas = null
          resolve(dataURL)
        }
      })
    },
    //下载统筹单图片
    download(imgUrl, kh) {
      this.getUrlBase64(imgUrl, kh).then((base64) => {
        const link = document.createElement('canvas')
        link.href = base64
        link.download = `${this.insBillId}报价单.png`
        link.click()
      })
    },
  },
}
</script>
<style scoped lang="scss">
.tc-data {
  width: 100px;
}
.info-wrap {
  color: #000000;
  width: 100%;
  display: flex;
  flex-direction: column;
  //border: 1px solid #aaa;
  //border-radius: 4px;
  //box-shadow: 0 0 6px 0 #eee;
  .row-item-head {
    border-top: 1px solid #000000;
    font-size: 15px;
    color: #333;
    font-weight: bolder;
    margin-top: 20px;
    //background-color: #eee;
  }
  .base-info {
    padding: 0 15px;
    :deep(.info) {
      .info-item {
        margin: 5px;
      }
    }
  }
  .row-item {
    display: flex;
    justify-content: space-around;
    border-bottom: 1px solid #000000;
    //padding: 10px;
    // &:last-child {
    //   border: none;
    // }
    .div-left {
      justify-content: flex-start;
      padding-left: 5px;
    }
    div {
      font-size: 15px;
      height: 38px;
      flex: 1;
      display: flex;
      border-right: 1px solid #000000;
      justify-content: space-around;
      align-items: center;
    }
    div:first-child {
      border-left: 1px solid #000000;
    }
  }
}
.table-title {
  font-family: '黑体';
  font-size: 25px;
  font-weight: 800;
  color: #333;
  text-align: center;
  border-bottom: 1px solid #000000;
  padding-bottom: 50px;
}
.info-footer {
  text-align: left;
  margin: 15px 0;
  color: #000000;
  font-size: 16px;
}

.remark {
  .remark-text {
    text-indent: 2em;
    margin-bottom: 10px;
    font-size: 16px;
    color: #000000;
  }
  .remark-title {
    margin-top: 10px;
    font-size: 16px;
    color: #000000;
  }
}
.bg-img {
  background-size: 70%;
  /* 背景图垂直、水平均居中 */
  background-position: center 100px;
  background-repeat: no-repeat;
  //background-color: #ffffff;
  // -webkit-filter: opacity(50%); /* Chrome, Safari, Opera */
  // filter: opacity(50%);
}
.jiaoqiang {
  font-size: 16px;
  color: #000000;
  margin-top: 10px;
  margin-bottom: 5px;
}
</style>
